<template>
  <div class="form-group">
    <label :for="'titleField_'+uniqueId">{{ label }}</label>
    <input
      :id="'titleField_'+uniqueId"
      class="form-control"
      v-model="inputValue"
      type="text"
      placeholder=""
    />
  </div>
</template>
<script>
  export default {
    name: 'TextField',
    props: {
      uniqueId: Number,
      label: String
    },
    computed:{
      inputValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
          return val;
        }
      }
    },
    data(){
      return{

      }
    }
  }
</script>
<style>
</style>
